import PropTypes from "prop-types";

export default function Description({ children, topMargin = true, title = "Overview" }) {
  return (
    <div className={`w-full mb-5 ${topMargin && "mt-4"} pl-5 pr-5 border-l-4 border-neutral-300`}>
      <div className="flex flex-col">
        <div className="font-medium text-md">
          <p className="pb-4 text-lg underline underline-offset-[5px] decoration-2 font-extrabold">
            {title}
          </p>
          {children}
        </div>
      </div>
    </div>
  );
}

Description.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  topMargin: PropTypes.bool,
};
